import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../get-base-url';
import { useParams } from 'react-router-dom';
import ResearchCivilUnionNonResidentNotificationShared from '../../research-notifications/research-civil-union-non-resident';
import { BreadcrumbItem } from '../../breadcrumb';

interface ResearchCivilUnionNonResidentNotificationCivilStatusSharedProps {
  scope?: string;
  items?: BreadcrumbItem[];
}

const ResearchCivilUnionNonResidentNotificationCivilStatusShared = ({
  scope,
  items,
}: ResearchCivilUnionNonResidentNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idCat = params.idCat || undefined;
  const idAnsc = params.id || undefined;
  const idNotifica = params.idNotifica || '';

  const goBackUrl: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/modifica/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  const editSipoUrl: string = useMemo(() => {
    return `${goBackUrl}/unione-civile/non-residenti/persona-sipo`;
  }, [goBackUrl]);

  const redirectUrl: string = useMemo(() => {
    return `${goBackUrl}/unione-civile/non-residenti/registrazione/:idIntestatario/:idSchedaSoggettoANPR`;
  }, [goBackUrl]);

  return (
    <Fragment>
      <ResearchCivilUnionNonResidentNotificationShared
        goBackUrl={goBackUrl}
        redirectUrl={redirectUrl}
        items={items}
        editSipoUrl={editSipoUrl}
      />
    </Fragment>
  );
};

ResearchCivilUnionNonResidentNotificationCivilStatusShared.displayName =
  'Research CivilUnion Non Resident Notifications Page component';

export default ResearchCivilUnionNonResidentNotificationCivilStatusShared;
